import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getCard } from '@/react-query/services/card';

import { Card, CardType } from '@generated-types';
import { useCardId } from '@hooks/card/use-card-id';
import { useCardType } from '@hooks/card/use-card-type';

export const useCardByTypeAndId = (type: CardType | undefined, id: string | undefined, enabled = true) => {
    return useQuery<Card>({
        queryKey: ['card', type, id],
        queryFn: () => getCard(type!, id!),
        enabled: !!id && !!type && enabled,
    });
};

export const useCard = (enabled = true) => {
    const cardId = useCardId();
    const cardType = useCardType();

    return useCardByTypeAndId(cardType, cardId, enabled);
};

export const useInvalidateCardQuery = () => {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries({ queryKey: ['v4'] });
    };
};
